import React, { useState, useEffect } from "react";
import {useStateValue} from "../../../../State";

import Moment           from "moment";

import Languages        from "../../../../translations";

import Accordion        from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon   from '@mui/icons-material/ExpandMore';
import Typography       from "@mui/material/Typography";

import Table            from '@mui/material/Table';
import TableBody        from "@mui/material/TableBody";
import TableCell        from "@mui/material/TableCell";
import TableHead        from "@mui/material/TableHead";
import TableRow         from "@mui/material/TableRow";

import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  nobottomline: {
    borderBottom: "none",
    color: "black",
    backgroundColor: "#ffffff",
    flex: "0 0 100%"
  },
}));

const ChildSupportFollowUp = (props) => {

  const classes = useStyles();

  const { Form, callback, closeView } = props;

  const { state/*, actions*/ } = useStateValue();
  const Table3   = state.leops.Table3;
  const SubModel = Table3.SupportPlanModel;

  const [expanded, setExpanded] = useState(false);

  //console.log("CheckingSpecialSupport. MOUNT. SubModel: ", SubModel);

  const toggleExpanded = () => {
    setExpanded(!expanded);
    callback("CSS");
  }

  useEffect(() => {
    //console.log("Table1. useEffect. Close view");
    setExpanded(false);
  },[closeView]); 

  return (
      <Accordion className="painikkeet"
                 style={{ backgroundColor: "#4377BA"/*, color: "black"*/ }}
                 //disabled = {item.Saved === "" ? true: false}
                 expanded={expanded}
                 onChange={() => toggleExpanded()}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel3a-content"
                          id="test_Leops_SupportTableCSS">
          <Typography className="heading"> {Languages.AdditionaMethods}</Typography>
        </AccordionSummary>
        <div className={classes.nobottomline}>
            {SubModel.Selection1Date && (
                <AccordionDetails>
                {Languages.SupportMethodsAreEnough + ", " + Moment(SubModel.Selection1Date).format("DD.MM.YYYY")}
                </AccordionDetails>
            )}

            {SubModel.Selection2Date && (
                <AccordionDetails>
                {Languages.SupportMethodsNeedUpdating + ", " + Moment(SubModel.Selection2Date).format("DD.MM.YYYY")}
                </AccordionDetails>
            )}

            {SubModel.Selection3Date && (
                <AccordionDetails>
                {Languages.SupportMethodsNeedNewEvaluation + ", " + Moment(SubModel.Selection3Date).format("DD.MM.YYYY")}
                </AccordionDetails>
            )}
                    </div>
                </Accordion>
  );
}

export default ChildSupportFollowUp;